import { render, staticRenderFns } from "./couponAddQuotaModal.vue?vue&type=template&id=16c27d01&scoped=true"
import script from "./couponAddQuotaModal.vue?vue&type=script&lang=js"
export * from "./couponAddQuotaModal.vue?vue&type=script&lang=js"
import style0 from "./couponAddQuotaModal.vue?vue&type=style&index=0&id=16c27d01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c27d01",
  null
  
)

export default component.exports